module.exports = __webpack_public_path__ + "banner_iphone16_mass_800x400.d0071239.png";